export default "__VITE_ASSET__BBPY7jES__"